
import _ from 'lodash'

type TypeElement = {
    type: string
    value?: string
    children?: TypeElement[]
}

export const formatTitleId = (array: TypeElement[]) => {
    return _.kebabCase(nestedMap(array).join(""))
}

const nestedMap = (array: TypeElement[]):string[] => {
    return array.map((item: TypeElement) => {
        if (item.type === 'element') {
            return nestedMap(item.children!)
        } else {
            return returnValue(item)
        }
    })
        .flat()    
}

const returnValue = (x: TypeElement):string => x.value!